import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import busterPunchLogo from "@/assets/buster-punch-logo.png?format=webp&quality=85&w=400";
import storyImageSrc from "@/assets/bp-story-interior.jpg?format=webp&quality=75&w=600;900;1200&as=srcset";
import storyImageFallback from "@/assets/bp-story-interior.jpg?format=webp&quality=75&w=900";

export const BusterPunch = () => {
  const { t, language } = useLanguage();
  const bp = t.busterPunch;

  return (
    <section className="bg-charcoal pt-4 lg:pt-6 pb-16 lg:pb-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 lg:mb-24">
          <img src={busterPunchLogo} alt="Buster + Punch" width={400} height={200} loading="lazy" decoding="async" className="h-20 lg:h-28 xl:h-36 w-auto mx-auto mb-6" />
          <p className="text-ivory/60 max-w-2xl mx-auto text-lg">{bp.brandDescription}</p>
          <div className="mt-8 flex items-center justify-center gap-6">
            <div className="h-px w-24 bg-gradient-to-r from-transparent to-gold/50" />
            <div className="w-2 h-2 rotate-45 bg-gold/50" />
            <div className="h-px w-24 bg-gradient-to-l from-transparent to-gold/50" />
          </div>
        </div>

        <div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            <div>
              <div className="aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src={storyImageFallback}
                  srcSet={storyImageSrc}
                  sizes="(min-width: 1024px) 50vw, 100vw"
                  alt="Buster + Punch interior"
                  width={900}
                  height={675}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div>
              <span className="text-gold font-display text-xs tracking-[0.3em] uppercase mb-4 block">{bp.theStory}</span>
              <h3 className="font-display text-2xl lg:text-3xl xl:text-4xl text-ivory mb-6 leading-tight">{bp.mastersOfMetal}</h3>
              <div className="text-ivory/70 leading-relaxed space-y-4 text-sm lg:text-base">
                <p>{bp.storyParagraph1}</p>
              </div>
            </div>
          </div>
          
          <div className="mt-12 lg:mt-16 flex justify-center">
            <Link to={`/${language}/shop?brands=Buster+%2B+Punch`} className="inline-flex items-center gap-2 bg-gradient-to-r from-gold to-gold-light text-charcoal font-display text-sm tracking-wider px-10 py-4 rounded-full hover:from-gold-light hover:to-gold transition-all shadow-lg shadow-gold/30 border border-gold/50">
              {language === 'lv' ? 'APSKATĪT BUSTER + PUNCH' : language === 'ru' ? 'ПОСМОТРЕТЬ КОЛЛЕКЦИЮ BUSTER + PUNCH' : bp.shopBusterPunch}
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
